// src/components/LoginWithGoogle.js
import React from "react";
import { GoogleLogin } from "@react-oauth/google";
import { GoogleAuthProvider, signInWithCredential } from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";

const LoginWithGoogle = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from || "/tracker";

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <GoogleLogin
        onSuccess={async (credentialResponse) => {
          try {
            const credential = GoogleAuthProvider.credential(
              credentialResponse.credential
            );
            await signInWithCredential(auth, credential);
            console.log("✅ Firebase login med Google JWT-token");
            navigate(from);
          } catch (err) {
            console.error("Loginfejl:", err);
          }
        }}
        onError={() => {
          console.error("Google login fejl");
        }}
      />
    </Box>
  );
};

export default LoginWithGoogle;
